import React from 'react';
import SeedImage from 'assets/seed-of-success.png';

export const SeedsOfSuccess = () => {
  return (
    <section className="w-full bg-white py-12 px-6 md:px-16 flex flex-col md:flex-row items-center justify-between">
      {/* Left Side - Text */}
      <div className="w-full md:w-1/2 text-center md:text-left mb-10 md:mb-0">
        <h2 className="text-3xl sm:text-4xl font-bold text-green-700 mb-6">
          PLANT SEEDS OF SUCCESS
        </h2>
        <p className="text-gray-700 text-lg leading-relaxed">
          We will train you to grow to your fullest potential. You’ll receive executive level
          training based with real-world insights from leaders who have served in top management
          firms. Our trainings are designed for entrepreneurs by entrepreneurs. Join a one-time
          workshop, the Aspire Launchpad for idea-stage businesses, or dive into the rich soil of
          our intensive Entrepreneur Academy.
        </p>
      </div>

      {/* Right Side - Image */}
      <div className="w-full md:w-1/2 flex justify-center md:justify-end">
        <img src={SeedImage} alt="Seed of Success" className="max-w-xs sm:max-w-sm" />
      </div>
    </section>
  );
};
